import React, { useEffect, useState } from "react";
import Container from "Components/Container/Container";
import Hero from "./Hero/Hero";
import CategoryTabs from "./CategoryTabs/CategoryTabs";
import TraniningAndWorkShop from "./TraniningAndWorkShop/TraniningAndWorkShop";
import TrainingMaterial from "./TrainingMaterial/TrainingMaterial";
import { useLocation } from "react-router-dom";

const AcademyMainPage = () => {
  const defaultCategory = "trainings-and-workshops";
  const [selectedCategory, setSelectedCategory] = useState(defaultCategory);

  const location = useLocation();

  useEffect(() => {
    // Check if a specific category is passed in location state or query string
    const locationCategory =
      location.state?.selectedCategory ||
      new URLSearchParams(location.search).get("category");

    // Update only if there's a valid category in location
    if (locationCategory && locationCategory !== selectedCategory) {
      setSelectedCategory(locationCategory);
    }
  }, [location, selectedCategory]);

  const renderContent = () => {
    switch (selectedCategory) {
      case "trainings-and-workshops":
        return <TraniningAndWorkShop />;
      case "training-materials":
        return <TrainingMaterial />;
      case "certifications":
        return (
          <h1 className="text-3xl font-bold text-white uppercase mb-4">
            Certifications
          </h1>
        );
      default:
        return <TraniningAndWorkShop />;
    }
  };

  return (
    <main className="scroll-section-special">
      <Hero />
      <Container>
        <div className="lg:-mt-[22vh] pt-[3vh] grid grid-cols-1 lg:grid-cols-4 gap-x-10 pb-primary bg-[#0000009a] rounded-md">
          {/* Sticky CategoryTabs */}
          <div className="lg:col-span-1">
            <div className="lg:sticky lg:top-[10vh]">
              <CategoryTabs
                selectedCategory={selectedCategory}
                setSelectedCategory={setSelectedCategory}
              />
            </div>
          </div>

          {/* Content area that takes up natural height */}
          <div className="col-span-3">{renderContent()}</div>
        </div>
      </Container>
    </main>
  );
};

export default AcademyMainPage;
